
import React, { useRef, useState } from 'react';
import { Card, Row, Col, Typography, Flex, Button, Table, Progress, Select } from 'antd';
import Chart from 'react-apexcharts';
import { ExecutivePieChart } from './helperChart';
import "./executivestyle.css"
import logo from '@/assets/seaflashlogo.png';
import GaugeChart from '@/pages/Dashboard/Charts/Gaugechart/GaugeChart';
import {
    Document, Page, Image,
    pdf,
    View, Text,
    StyleSheet
} from '@react-pdf/renderer';
import html2canvas from 'html2canvas';
import { Download } from 'lucide-react';
import MarineGaugeChart from '@/pages/Dashboard/Charts/Gaugechart/CustomGauge';
import VesselPerformanceDashboard from './VesselPerformanceDashboard';
import { glassyCardStyle, styles } from './downloadStyles';
const { Title } = Typography;

const ExecutiveSummary = () => {
    const dashboardRef1 = useRef(null);
    const dashboardRef2 = useRef(null);
    const dashboardRef3 = useRef(null);
    const dashboardRef4 = useRef(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const downloadPDF = async () => {
        if (!dashboardRef1.current) return;
        setIsDownloading(true);

        try {

            const canvas1 = await html2canvas(dashboardRef1.current, {
                scale: 3,
                useCORS: true,
                allowTaint: false,
                backgroundColor: '#ffffff',
                removeContainer: true,
                scrollY: -window.scrollY,


            });

            const canvas2 = await html2canvas(dashboardRef2.current, {
                scale: 3,
                useCORS: true,
                allowTaint: false,
                backgroundColor: '#ffffff',
                removeContainer: true,
                scrollY: -window.scrollY,

            });

            const canvas3 = await html2canvas(dashboardRef3.current, {
                scale: 3,
                useCORS: true,
                allowTaint: false,
                backgroundColor: '#ffffff',
                removeContainer: true,
                scrollY: -window.scrollY,

            });

            const canvas4 = await html2canvas(dashboardRef4.current, {
                scale: 3,
                useCORS: true,
                allowTaint: false,
                backgroundColor: '#ffffff',
                removeContainer: true,
                scrollY: -window.scrollY,

            });

            // Convert canvases to image data
            const imgData1 = canvas1.toDataURL('image/png');
            const imgData2 = canvas2.toDataURL('image/png');
            const imgData3 = canvas3.toDataURL('image/png');
            const imgData4 = canvas4.toDataURL('image/png');



            const MyDocument = () => (
                <Document>
                    {/* Page 1 */}
                    <Page size="A4" style={{ padding: 20 }}>
                        <View style={styles.borderBox} fixed />
                        <View style={styles.header} fixed>
                            <Image src={logo} style={styles.logo} />

                            <Text style={styles.topic}>Executive Summary</Text>
                            <Text style={styles.title}>SEA FLASH</Text>
                        </View>
                        <Image src={imgData1} style={styles.dashboardImage} />
                        <Text style={styles.footer} fixed>SEA FLASH · Brilliance In Every Flash</Text>
                    </Page>

                    {/* Page 2 */}
                    <Page size="A4" style={{ padding: 20 }}>
                        <View style={styles.borderBox} fixed />
                        <View style={styles.header} fixed>
                            <Image src={logo} style={styles.logo} />
                            <Text style={styles.title}>SEA FLASH</Text>
                        </View>
                        <Image src={imgData2} style={styles.dashboardImage} />
                        <Text style={styles.footer} fixed>SEA FLASH · Brilliance In Every Flash</Text>
                    </Page>

                    {/* Page 3 */}
                    <Page size="A4" style={{ padding: 20 }}>
                        <View style={styles.borderBox} fixed />
                        <View style={styles.header} fixed>
                            <Image src={logo} style={styles.logo} />
                            <Text style={styles.title}>SEA FLASH</Text>
                        </View>
                        <Image src={imgData3} style={styles.dashboardImage} />
                        <Text style={styles.footer} fixed>SEA FLASH · Brilliance In Every Flash</Text>
                    </Page>

                    {/* Page 4 */}
                    <Page size="A4" style={{ padding: 20 }}>
                        <View style={styles.borderBox} fixed />
                        <View style={styles.header} fixed>
                            <Image src={logo} style={styles.logo} />
                            <Text style={styles.title}>SEA FLASH</Text>
                        </View>
                        <Image src={imgData4} style={styles.dashboardImage} />
                        <Text style={styles.footer} fixed>SEA FLASH · Brilliance In Every Flash</Text>
                    </Page>
                </Document>
            );

            const pdfBlob = await pdf(<MyDocument />).toBlob();
            const url = URL.createObjectURL(pdfBlob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'executive-summary.pdf';
            link.click();
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error generating PDF:', error);
        } finally {
            setIsDownloading(false);
        }
    };


    // Image 1 Charts Configuration
    const createDonutChart = (value, colors, label) => ({
        chart: {
            type: 'donut',
            height: 150,
            animations: {
                enabled: true,
                easing: 'easeinout',
                speed: 1000
            },
            background: 'transparent',
            toolbar: {
                show: false
            },
            dropShadow: {
                enabled: true,
                top: 3,
                left: 0,
                blur: 6,
                opacity: 0.15
            }
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '80%',
                    labels: {
                        show: true,
                        name: {
                            show: true,
                            fontSize: '12px',
                            fontWeight: 500,
                            color: '#666',
                            offsetY: 20
                        },
                        value: {
                            show: true,
                            fontSize: '24px',
                            fontWeight: 'bold',
                            color: Array.isArray(colors) ? colors[0] : colors,
                            offsetY: -8,
                            formatter: (val) => `${val}%`
                        },
                        total: {
                            show: true,
                            label: label,
                            fontSize: '12px',
                            fontWeight: 500,
                            color: '#666'
                        }
                    }
                }
            }
        },
        fill: {
            type: 'gradient',
            gradient: {
                shade: 'light',
                type: 'vertical',
                shadeIntensity: 0.3,
                gradientToColors: Array.isArray(colors) ? [colors[1]] : [colors],
                inverseColors: false,
                opacityFrom: 1,
                opacityTo: 0.8,
                stops: [0, 100]
            }
        },
        colors: Array.isArray(colors) ? [colors[0], '#f0f0f0'] : [colors, '#f0f0f0'],
        labels: ['Progress', 'Remaining'],
        legend: {
            show: false
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        tooltip: {
            enabled: true,
            theme: 'light',
            style: {
                fontSize: '12px'
            },
            y: {
                formatter: (val) => `${val}%`
            }
        }
    });

    // Load Profiles Pie Charts (Image 1)
    const loadProfilePie = {
        chart: {
            type: 'pie',
        },
        colors: ['#ff4d4f', '#1890ff', '#52c41a'],
        legend: {
            show: false
        },
        dataLabels: {
            enabled: true,
            formatter: (val) => Math.round(val) + '%',
            style: {
                fontSize: '14px',
            }
        }
    };

    // Machinery Performance Donut (Image 1)
    const machineryDonut = {
        chart: {
            type: 'donut',
            height: 150,
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '60%',
                    labels: {
                        show: true,
                        value: {
                            show: true,
                            fontSize: '16px',
                            fontWeight: 'bold',
                            color: '#1890ff',
                            formatter: (val) => val + '%'
                        }
                    }
                }
            }
        },
        colors: ['#1890ff', '#52c41a', '#ff4d4f'],
        labels: ['Sludge Generation', 'Port Load', 'Other'],
        legend: { show: false },
        dataLabels: { enabled: false }
    };

    // Fuel Performance Bar Chart (Image 1) - Updated to match image
    const fuelBarChart = {
        chart: {
            type: 'bar',
            height: 200,
            toolbar: { show: false }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '40%',
                distributed: false
            }
        },
        colors: ['#1890ff', '#ff4d4f', '#52c41a'],
        xaxis: {
            categories: ['Fuel', 'Perm', 'Other'],
            labels: {
                show: true,
                style: {
                    fontSize: '10px'
                }
            }
        },
        yaxis: {
            labels: {
                formatter: (val) => val + '%'
            },
            max: 40
        },
        legend: { show: false },
        dataLabels: {
            enabled: true,
            formatter: (val) => val + '%',
            style: {
                fontSize: '10px',
                colors: ['#fff']
            }
        }
    };


    // Image 2 Charts Configuration

    const vesselPerformanceoptions = {
        chart: {
            type: 'donut',
            background: 'transparent'
        },
        series: [12.5, 12.5, 12.5, 12.5, 12.5, 12.5, 12.5, 12.5],
        labels: ['Vessel 1', 'Vessel 2', 'Vessel 3', 'Vessel 4', 'Vessel 5', 'Vessel 6', 'Vessel 7', 'Vessel 8'],
        colors: ['#1e40af', '#1d4ed8', '#2563eb', '#3b82f6', '#60a5fa', '#93c5fd', '#bfdbfe', '#dbeafe'],
        plotOptions: {
            pie: {
                donut: {
                    size: '50%',
                    labels: {
                        show: true,
                        total: {
                            show: true,
                            label: 'Overall Performance',
                            formatter: () => '75%'
                        }
                    }
                }
            }
        },
        dataLabels: {
            enabled: true,
            style: {
                colors: ['#fff']
            },
            formatter: function (val, opts) {
                const label = opts.w.config.labels[opts.seriesIndex];
                const value = opts.w.config.series[opts.seriesIndex];
                return label;
            }
        },
        legend: {
            show: false
        }
    };

    const createEfficiencyGaugeChart = (value, label, color = '#20E647', target = 100) => {
        const getColorByValue = (val) => {
            if (val >= 80) return '#20E647'; // Green
            if (val >= 60) return '#FFC107'; // Yellow
            if (val >= 40) return '#FF9800'; // Orange
            return '#F44336'; // Red
        };

        return {
            chart: {
                type: 'radialBar',
                height: 200,
                width: 200,
                background: 'transparent'
            },
            plotOptions: {
                radialBar: {
                    startAngle: -90,
                    endAngle: 90,
                    hollow: {
                        margin: 15,
                        size: '70%',
                        background: 'transparent'
                    },
                    track: {
                        background: 'rgba(255,255,255,0.2)',
                        strokeWidth: '100%',
                        margin: 5,
                    },
                    dataLabels: {
                        name: {
                            show: true,
                            color: '#fff',
                            fontSize: '12px',
                            fontWeight: 'bold',
                            offsetY: 10
                        },
                        value: {
                            show: true,
                            color: '#fff',
                            fontSize: '24px',
                            fontWeight: 'bold',
                            offsetY: -5,
                            formatter: function (val) {
                                return parseInt(val) + '%';
                            }
                        }
                    }
                }
            },
            fill: {
                type: 'solid',
                colors: [color || getColorByValue(value)]
            },
            stroke: {
                lineCap: 'round'
            },
            labels: [label],
            series: [value],
            colors: [color || getColorByValue(value)]
        };
    };
    // Fleet Performance Donut (Image 2)
    const fleetPerformanceDonut = {
        chart: {
            type: 'donut',
            height: 200,
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '70%',
                    labels: {
                        show: true,
                        value: {
                            show: true,
                            fontSize: '32px',
                            fontWeight: 'bold',
                            color: '#3287d6ff',
                            formatter: (val) => val + '%'
                        },
                        total: {
                            show: true,
                            label: 'Overall Performance',
                            fontSize: '12px',
                            color: '#666'
                        }
                    }
                }
            }
        },
        colors: ['#1890ff', '#f0f0f0'],
        labels: ['Performance', 'Remaining'],
        legend: { show: false },
        dataLabels: { enabled: false }
    };

    // Energy Efficiency Gauges (Image 2)
    const createGaugeChart = (value, title, color) => ({
        chart: {
            type: 'radialBar',
            height: 100,
        },
        plotOptions: {
            radialBar: {
                hollow: {
                    size: '50%',
                },
                dataLabels: {

                    name: {
                        fontSize: '10px',
                        color: '#666',
                        offsetY: 15,
                    },
                    value: {
                        fontSize: '12px',
                        fontWeight: 'bold',
                        color: color,
                        offsetY: -20,
                        formatter: (val) => val + '%'
                    },
                }
            }
        },
        colors: [color],
        labels: [title],
    });


    // Image 3 Charts Configuration

    // Horizontal Progress Bars (Image 3)
    const createHorizontalBar = (categories, title) => ({
        chart: {
            type: 'bar',
            toolbar: { show: false }
        },
        plotOptions: {
            bar: {
                horizontal: true,
                barHeight: '70%',
                distributed: false
            }
        },
        colors: ['#faad14', '#1890ff', '#52c41a'],
        xaxis: {
            categories: categories,
            labels: {
                formatter: (val) => val + '%'
            }
        },
        yaxis: {
            labels: {
                style: {
                    fontSize: '12px',
                    fontWeight: 'bold'
                }
            }
        },

        title: {
            text: title,
            align: 'left',
            style: {
                fontSize: '18px',
                fontWeight: 'bold',
                color: 'black'
            },
            margin: 20
        },
        legend: { show: false },
        dataLabels: {
            enabled: true,
            formatter: (val) => val + '%',
            style: {
                fontSize: '10px',
                colors: ['#fff']
            }
        }
    });



    const portSeaLoadOptions = {
        chart: {
            type: 'column',
            height: 300,
        },
        colors: ['#94A3B8', '#94A3B8', '#94A3B8', '#94A3B8', '#EF4444', '#22C55E'],
        plotOptions: {
            bar: {
                columnWidth: '60%',
                borderRadius: 2
            }
        },
        xaxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
            labels: { style: { colors: 'black' } }
        },


        title: {
            text: 'Port Load vs. Sea Load',
            style: { color: 'black', fontSize: '14px' }
        },
        legend: { show: false }
    };
    const portSeaLoadSeries = [{
        name: 'Load',
        data: [65, 75, 85, 70, 45, 90]
    }];

    const chartOptions = {
        chart: {
            type: 'bar',
            toolbar: { show: false },
            stacked: false
        },
        colors: ['#94A3B8', '#EF4444', '#EAB308', '#06B6D4'],
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '70%',
                borderRadius: 2,
                dataLabels: {
                    position: 'top'
                }
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            show: true,
            width: 2,
        },
        xaxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            labels: {
                style: {
                    colors: 'black',
                    fontSize: '12px'
                }
            },
            axisBorder: {
                show: true,
                color: '#374151'
            },
            axisTicks: {
                show: true,
                color: '#374151'
            }
        },
        yaxis: {
            labels: {
                style: {
                    colors: 'black',
                    fontSize: '12px'
                }
            },
            gridLines: {
                show: true
            }
        },

        title: {
            text: 'Machinery Performance',
            align: 'left',
            style: {
                fontSize: '18px',
                fontWeight: 'bold',
                color: 'black'
            },
            margin: 20
        },
        tooltip: {
            theme: 'dark',
            y: {
                formatter: function (val) {
                    return val + " units"
                }
            }
        },
        responsive: [{
            options: {
                legend: {
                    position: 'bottom',
                    offsetY: 10
                }
            }
        }]
    };

    const chartSeries = [
        {
            name: 'Main Monthly Parameter',
            data: [65, 72, 78, 85, 82, 88, 92, 89, 95, 98, 94, 91]
        },
        {
            name: 'Aux Engine Parameter',
            data: [45, 52, 58, 62, 59, 65, 68, 71, 74, 78, 75, 72]
        },
        {
            name: 'Aux Engine Load Share',
            data: [25, 28, 32, 35, 38, 42, 45, 48, 52, 55, 58, 60]
        },
        {
            name: 'Main Engine Running Hours & Events',
            data: [15, 18, 22, 25, 28, 32, 35, 38, 42, 45, 48, 52]
        }
    ];


    // Fuel Balance Chart
    const fuelBalanceOptions = {
        chart: {
            type: 'bar',
            height: 300,
            background: 'transparent',
            toolbar: { show: false }
        },
        colors: ['#F59E0B', '#EF4444', '#06B6D4'],
        plotOptions: {
            bar: {
                horizontal: true,
                barHeight: '60%',
                borderRadius: 4
            }
        },
        dataLabels: { enabled: false },
        xaxis: {
            categories: ['Fuel Balance', 'Engine Oil', 'Hydraulic Oil'],
            labels: { style: { colors: 'black' } }
        },
        yaxis: {
            labels: { style: { colors: 'black' } }
        },
        grid: {
            borderColor: '#374151',
            strokeDashArray: 3
        },
        title: {
            text: ' Downtime Tracking',
            style: { color: 'black', fontSize: '16px', fontWeight: 'bold' }
        },
        legend: { show: false }
    };

    const fuelBalanceSeries = [{
        name: 'Level',
        data: [75, 45, 85]
    }];

    const offHireEventsOptions = {
        chart: {
            type: 'bar',
            height: 300,
            background: 'transparent',
            toolbar: { show: false }
        },
        colors: ['#EAB308'],
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '70%',
                borderRadius: 4
            }
        },
        dataLabels: { enabled: false },
        xaxis: {
            categories: ['Q1', 'Q2', 'Q3', 'Q4'],
            labels: { style: { colors: 'black' } }
        },
        yaxis: {
            labels: { style: { colors: 'black' } }
        },
        grid: {
            borderColor: '#374151',
            strokeDashArray: 3
        },
        title: {
            text: 'Off-Hire Events',
            style: { color: 'black', fontSize: '16px', fontWeight: 'bold' }
        },
        legend: { show: false }
    };

    const offHireEventsSeries = [{
        name: 'Events',
        data: [8, 12, 6, 15]
    }];


    const fuelLubricationOptions = {
        chart: {
            type: 'bar',
            height: 350,
            background: 'transparent',
            toolbar: { show: false }
        },
        colors: ['#3B82F6', '#EF4444', '#EAB308'],
        plotOptions: {
            bar: {
                horizontal: true,
                columnWidth: '60%',
                borderRadius: 4
            }
        },
        dataLabels: { enabled: false },
        xaxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug'],
            labels: { style: { colors: 'black' } }
        },
        yaxis: {
            labels: { style: { colors: 'black' } }
        },
        grid: {
            borderColor: '#374151',
            strokeDashArray: 3
        },
        legend: {
            show: true,
            position: 'top',
            labels: {
                colors: 'black'
            },
            markers: {
                width: 12,
                height: 12,
                strokeWidth: 0,
                radius: 2
            }
        },
        title: {
            text: 'Fuel & Lubrication Monitoring',
            style: { color: 'black', fontSize: '16px', fontWeight: 'bold' }
        }
    };

    const fuelLubricationSeries = [
        {
            name: 'Fuel Balance',
            data: [75, 68, 82, 78, 85, 72, 88, 80]
        },
        {
            name: 'Sludge Generation',
            data: [25, 32, 28, 35, 30, 38, 25, 33]
        },
        {
            name: 'Lube Oil Consumption',
            data: [45, 52, 48, 55, 50, 58, 52, 60]
        }
    ];
    const chartOptions1 = {
        chart: {
            type: 'donut'
        },
        colors: ['#FFD700', '#FF8C00', '#FF4444', '#8B5CF6', '#3B82F6', '#06B6D4', '#10B981'],
        labels: [
            'Energy Efficiency Metrics',
            'Operational Load Profiles',
            'Operational Load Profiles',
            'Fuel & Lubrication Monitoring',
            'Machinery Performance',
            'Maintenance & Equipment Insights',
            'Downtime Tracking'
        ],
      
        plotOptions: {
            pie: {
                donut: {
                    size: '70%', // You can increase to '80%' for a thicker donut
                    labels: {
                        show: true,
                        value: {
                            show: true,
                            fontSize: '28px',
                            fontWeight: 'bold',
                            color: '#3287d6ff',
                            formatter: (val) => `${val}%`
                        },
                        total: {
                            show: true,
                            label: 'Overall performance rating',
                            fontSize: '14px',
                            color: '#666'
                        }
                    }
                }
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            width: 0
        },
        legend: {
            show: false,
        },
        states: {
            hover: {
                filter: { type: 'none' }
            },
            active: {
                filter: { type: 'none' }
            }
        },
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: 300
                    }
                }
            }
        ]
    };


    const chartSeries1 = [20, 15, 12, 18, 15, 12, 8];

    // Table columns configuration
    const columns = [
        {
            title: '',
            dataIndex: 'vessel',
            key: 'vessel',
            width: 100,
            render: (text) => <span style={{ fontWeight: 'bold' }}>{text}</span>
        },
        {
            title: (
                <div style={{ color: '#FFD700', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '12px', height: '12px', backgroundColor: '#FFD700', borderRadius: '50%' }}></div>
                    Energy Efficiency Metrics
                </div>
            ),
            dataIndex: 'energyEfficiency',
            key: 'energyEfficiency',
            width: 200,
            render: (value) => (
                <Progress
                    percent={value}
                    showInfo={false}
                    strokeColor="#FFD700"
                    trailColor="#2D3748"
                    size="small"
                />
            )
        },
        {
            title: (
                <div style={{ color: '#FF4444', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '12px', height: '12px', backgroundColor: '#FF4444', borderRadius: '50%' }}></div>
                    Operational Load Profiles
                </div>
            ),
            dataIndex: 'operationalLoad',
            key: 'operationalLoad',
            width: 200,
            render: (value) => (
                <Progress
                    percent={value}
                    showInfo={false}
                    strokeColor="#FF4444"
                    trailColor="#2D3748"
                    size="small"
                />
            )
        },
        {
            title: (
                <div style={{ color: '#8B5CF6', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '12px', height: '12px', backgroundColor: '#8B5CF6', borderRadius: '50%' }}></div>
                    Fuel & Lubrication Monitoring
                </div>
            ),
            dataIndex: 'fuelLubrication',
            key: 'fuelLubrication',
            width: 200,
            render: (value) => (
                <Progress
                    percent={value}
                    showInfo={false}
                    strokeColor="#8B5CF6"
                    trailColor="#2D3748"
                    size="small"
                />
            )
        },
        {
            title: (
                <div style={{ color: '#06B6D4', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '12px', height: '12px', backgroundColor: '#06B6D4', borderRadius: '50%' }}></div>
                    Maintenance & Equipment Insights
                </div>
            ),
            dataIndex: 'maintenance',
            key: 'maintenance',
            width: 200,
            render: (value) => (
                <Progress
                    percent={value}
                    showInfo={false}
                    strokeColor="#06B6D4"
                    trailColor="#2D3748"
                    size="small"
                />
            )
        },
        {
            title: (
                <div style={{ color: '#10B981', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '12px', height: '12px', backgroundColor: '#10B981', borderRadius: '50%' }}></div>
                    Downtime Tracking
                </div>
            ),
            dataIndex: 'downtime',
            key: 'downtime',
            width: 200,
            render: (value) => (
                <Progress
                    percent={value}
                    showInfo={false}
                    strokeColor="#10B981"
                    trailColor="#2D3748"
                    size="small"
                />
            )
        },
        {
            title: (
                <div style={{ color: '#10B981', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '12px', height: '12px', backgroundColor: '#10B981', borderRadius: '50%' }}></div>
                    Downtime Tracking
                </div>
            ),
            dataIndex: 'downtime',
            key: 'downtime',
            width: 200,
            render: (value) => (
                <Progress
                    percent={value}
                    showInfo={false}
                    strokeColor="#10B981"
                    trailColor="#2D3748"
                    size="small"
                />
            )
        },
        {
            title: (
                <div style={{ color: '#10B981', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '12px', height: '12px', backgroundColor: '#10B981', borderRadius: '50%' }}></div>
                    Downtime Tracking
                </div>
            ),
            dataIndex: 'downtime',
            key: 'downtime',
            width: 200,
            render: (value) => (
                <Progress
                    percent={value}
                    showInfo={false}
                    strokeColor="#10B981"
                    trailColor="#2D3748"
                    size="small"
                />
            )
        }
    ];

    // Table data
    const tableData = [
        {
            key: '1',
            vessel: 'Vessel A',
            energyEfficiency: 85,
            operationalLoad: 75,
            fuelLubrication: 90,
            maintenance: 95,
            downtime: 88
        },
        {
            key: '2',
            vessel: 'Vessel B',
            energyEfficiency: 78,
            operationalLoad: 68,
            fuelLubrication: 85,
            maintenance: 92,
            downtime: 85
        },
        {
            key: '3',
            vessel: 'Vessel C',
            energyEfficiency: 82,
            operationalLoad: 72,
            fuelLubrication: 88,
            maintenance: 89,
            downtime: 79
        },
        {
            key: '4',
            vessel: 'Vessel D',
            energyEfficiency: 90,
            operationalLoad: 80,
            fuelLubrication: 92,
            maintenance: 96,
            downtime: 91
        },
        {
            key: '5',
            vessel: 'Vessel E',
            energyEfficiency: 76,
            operationalLoad: 65,
            fuelLubrication: 83,
            maintenance: 87,
            downtime: 82
        },
        {
            key: '6',
            vessel: 'Vessel F',
            energyEfficiency: 81,
            operationalLoad: 70,
            fuelLubrication: 86,
            maintenance: 93,
            downtime: 86
        }
    ];

    // Legend data
    const legendItems = [
        { color: '#FFD700', label: 'Energy Efficiency Metrics' },
        { color: '#FF8C00', label: 'Operational Load Profiles' },
        { color: '#FF4444', label: 'Operational Load Profiles' },
        { color: '#8B5CF6', label: 'Fuel & Lubrication Monitoring' },
        { color: '#3B82F6', label: 'Machinery Performance' },
        { color: '#06B6D4', label: 'Maintenance & Equipment Insights' },
        { color: '#10B981', label: 'Downtime Tracking' }
    ];

    const MobileContainer = ({ children }) => (
        <Row justify="center">
            <Col xs={24} sm={20} md={16} lg={12}>
                <div style={{ background: '#f0f2f5', padding: 12 }}>
                    {children}
                </div>
            </Col>
        </Row>
    );

    // Get today’s date
    const today = new Date();

    // Calculate the start of 3 months ago
    const startDate = new Date(today.getFullYear(), today.getMonth() - 2, 1); // First day of 2 months ago
    const endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0); // Last day of current month

    const lineoption = {
        chart: {
            type: "line",
            height: 120,
            zoom: { enabled: false },
            toolbar: { show: false }
        },
        title: {
            text: "Last 3Months Trend",
            style: { fontSize: "10px" }
        },
        stroke: {
            curve: "smooth",
            width: 2
        },
        xaxis: {
            type: "datetime",
            tickAmount: 3,
            min: startDate.getTime(), // dynamically calculated
            max: endDate.getTime(),   // dynamically calculated
            labels: {
                rotate: 0,
                datetimeUTC: false,
                style: {
                    fontSize: "10px",
                    colors: "#6E759F"
                },
                formatter: function (value) {
                    return new Date(value).toLocaleString("default", { month: "short" });
                }
            }
        },
        yaxis: {
            title: {
                style: { fontSize: "10px" }
            },
            labels: {
                style: {
                    fontSize: "10px",
                    colors: "#6E759F"
                },
                formatter: (value) => value.toFixed(2)
            }
        },
        tooltip: {
            enabled: true,
            style: { fontSize: "10px" }
        },
        colors: ["#008FFB"],
        dataLabels: {
            enabled: true,
            offsetY: -6,
            background: { enabled: false },
            style: {
                colors: ["#008FFB"],
                fontWeight: "bold",
                fontSize: "10px"
            },
            formatter: (value) => value.toFixed(2)
        },
        legend: { show: false },
        grid: {
            borderColor: "#E8E8E8",
            xaxis: { lines: { show: false } },
            yaxis: { lines: { show: true } }
        }
    };
    const lineSeries = [
        {
            name: "Data",
            data: [
                [new Date(today.getFullYear(), today.getMonth() - 2, 1).getTime(), 20],
                [new Date(today.getFullYear(), today.getMonth() - 1, 1).getTime(), 50],
                [new Date(today.getFullYear(), today.getMonth(), 1).getTime(), 30]
            ]
        }
    ];

    return (
        <MobileContainer
            style={{
                minHeight: '100vh',
            }}>
            <div className="container-fluid">
                <Flex justify='space-between' align='center' className='mb-2 p-2 bg-success-subtle rounded-3  '>
                    <Title level={4} className="fw-bold text-success my-auto ms-2" style={{ color: 'dark', marginBottom: '20px' }}>
                        Executive Summary
                    </Title>
                    <div className='d-flex'>
                        <Select className='w-100 h-50'
                            options={[]}
                            placeholder="Select Fleet events..."
                        />
                        <Button type='primary' icon={<Download size={18} />} onClick={downloadPDF} loading={isDownloading} className='ms-3'
                            disabled={isDownloading}>Download</Button>
                    </div>

                </Flex>

                {/* IMAGE 1  - Vessel Energy & Performance Dashboard */}
                <Row ref={dashboardRef1}>
                    <Card className='executivebox1 w-100 mb-3'  >
                        <Title level={4} className='text-center fw-bold mb-4' style={{ color: 'dark', }}>
                            Vessel Overall Performance
                        </Title>
                        <Row >
                            <Col span={12}>
                                <Chart options={vesselPerformanceoptions} series={vesselPerformanceoptions.series} type="donut" height={300} />
                            </Col>
                            <Col span={12}>
                                <div>
                                    <Typography.Text className="mb-0  " style={{ fontWeight: 'bold' }} >
                                        Energy Efficiency Metrics
                                    </Typography.Text>
                                    <Typography.Text style={{ color: 'grey', fontSize: '12px', display: 'block' }} className='mb-2'>
                                        Tracks a touting impact and drag performance.
                                    </Typography.Text>

                                    <div style={{ marginBottom: '5px' }}>
                                        <Typography.Text style={{ color: 'dark', fontSize: '14px', fontWeight: 'bold' }}>
                                            Main Engine Efficiency
                                        </Typography.Text>
                                        <Typography.Text style={{ color: 'grey', fontSize: '12px', display: 'block' }}>
                                            Evaluates deviation from benchmark parameters, fuel combustion quality, and thermal efficiency.
                                        </Typography.Text>
                                    </div>

                                    <div style={{ marginBottom: '10px' }}>
                                        <Typography.Text style={{ color: 'dark', fontSize: '14px', fontWeight: 'bold' }}>
                                            Auxiliary Engine Efficiency
                                        </Typography.Text>
                                        <Typography.Text style={{ color: 'grey', fontSize: '12px', display: 'block' }}>
                                            Assesses load balancing vs fuel used, monitored through steam trap checks and port/sea operation ratios
                                        </Typography.Text>
                                    </div>
                                    <div className='mt-2 me-3'>
                                        <Chart options={lineoption}
                                            series={lineSeries}
                                            height={130}
                                        />
                                    </div>
                                </div></Col>
                        </Row>
                    </Card>
                    <Card className='w-100'
                        style={{
                            border: 'none',
                        }}

                        bodyStyle={{ padding: '24px', }}
                    >
                        <Typography.Title level={4} className="fw-bold text-center  mb-3">
                            Vessel-Wise Energy & Performance
                        </Typography.Title>
                        <Row gutter={16} className='my-2'>
                            <Col span={12}  >
                                <Chart
                                    options={chartOptions1}
                                    series={chartSeries1}
                                    type="donut"
                                    height={250}
                                /></Col>
                            <Col span={12} className=' w-100'>
                                <Title level={5} style={{ color: 'dark', marginBottom: '15px' }}>
                                    Energy Efficiency Metrics
                                </Title>
                                <Typography.Text style={{ color: 'grey', fontSize: '12px', display: 'block', marginBottom: '15px' }}>
                                    Tracks a touting impact and drag performance.
                                </Typography.Text>

                                <div style={{ marginBottom: '15px' }} className='w-100'>
                                    <Typography.Text style={{ color: 'dark', fontSize: '14px', fontWeight: 'bold' }}>
                                        Main Engine Efficiency
                                    </Typography.Text>
                                    <Typography.Text style={{ color: 'grey', fontSize: '12px', display: 'block' }}>
                                        Evaluates deviation from benchmark parameters, fuel combustion quality, and thermal efficiency.
                                    </Typography.Text>
                                </div>

                                <div style={{ marginBottom: '15px' }}>
                                    <Typography.Text style={{ color: 'dark', fontSize: '14px', fontWeight: 'bold' }}>
                                        Auxiliary Engine Efficiency
                                    </Typography.Text>
                                    <Typography.Text style={{ color: 'grey', fontSize: '12px', display: 'block' }}>
                                        Assesses load balancing vs fuel used, monitored through steam trap checks and port/sea operation ratios
                                    </Typography.Text>
                                </div>

                            </Col>
                            <VesselPerformanceDashboard />
                        </Row>
                    </Card>
                </Row>

                {/* IMAGE 2 -  */}
                <div gutter={12} className='mt-3' ref={dashboardRef2}>
                    <Col md={24} style={{ marginBottom: '20px' }}>
                        <Card className='executivebox'>
                            <Row gutter={[16, 16]}>
                                <Col xs={24} md={12} lg={12}>
                                    <div  >
                                        <Title level={4} style={{ color: 'dark', marginBottom: '15px' }}>
                                            Overall Performance
                                        </Title>

                                        <Row  >
                                            <Col span={12}>
                                                <Chart
                                                    options={createDonutChart(35, '#1890ff', 'Port Load')}
                                                    series={[22, 65]}
                                                    type="donut"
                                                    height={150}
                                                />
                                            </Col>
                                            <Col span={12}>
                                                <Chart
                                                    options={createDonutChart(65, '#52c41a', 'Sea Load')}
                                                    series={[65, 35]}
                                                    type="donut"
                                                    height={150}
                                                />
                                            </Col>
                                            <Col span={12}>
                                                <Chart
                                                    options={createDonutChart(35, '#ff4d4f', 'Sea Load')}
                                                    series={[35, 65]}
                                                    type="donut"
                                                    height={150}
                                                />
                                            </Col>
                                            <Col span={12}>
                                                <Chart
                                                    options={createDonutChart(97, '#722ed1', 'Main Engine')}
                                                    series={[97, 3]}
                                                    type="donut"
                                                    height={150}
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>

                                {/* Energy Efficiency Metrics */}
                                <Col xs={24} md={12} lg={12}>
                                    <div>
                                        <Title level={5} style={{ color: 'dark', marginBottom: '15px' }}>
                                            Energy Efficiency Metrics
                                        </Title>
                                        <Typography.Text style={{ color: 'grey', fontSize: '12px', display: 'block', marginBottom: '15px' }}>
                                            Tracks a touting impact and drag performance.
                                        </Typography.Text>

                                        <div style={{ marginBottom: '15px' }}>
                                            <Typography.Text style={{ color: 'dark', fontSize: '14px', fontWeight: 'bold' }}>
                                                Main Engine Efficiency
                                            </Typography.Text>
                                            <Typography.Text style={{ color: 'grey', fontSize: '12px', display: 'block' }}>
                                                Evaluates deviation from benchmark parameters, fuel combustion quality, and thermal efficiency.
                                            </Typography.Text>
                                        </div>

                                        <div style={{ marginBottom: '15px' }}>
                                            <Typography.Text style={{ color: 'dark', fontSize: '14px', fontWeight: 'bold' }}>
                                                Auxiliary Engine Efficiency
                                            </Typography.Text>
                                            <Typography.Text style={{ color: 'grey', fontSize: '12px', display: 'block' }}>
                                                Assesses load balancing vs fuel used, monitored through steam trap checks and port/sea operation ratios
                                            </Typography.Text>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                    </Col>

                    <Col md={24}  >
                        <Card className='executivebox'>
                            <Row gutter={[16, 16]}>

                                <Col xs={24} md={12} lg={12}>
                                    <div>
                                        <Title level={4} style={{ color: 'dark', marginBottom: '15px' }}>
                                            Operational Load Profiles
                                        </Title>
                                        <Row>
                                            <Col span={12}>
                                                <ExecutivePieChart options={loadProfilePie}
                                                    series={[35, 0, 65]}
                                                    type="pie"
                                                    height={200}
                                                    colors={['#ff4d4f', '#1890ff', '#52c41a']}
                                                    labels={['Port Load 35%', 'Manoeuv 0%', 'Other']}
                                                />
                                            </Col>
                                            <Col span={12}>
                                                <ExecutivePieChart options={loadProfilePie}
                                                    series={[2, 0, 1]}
                                                    type="pie"
                                                    height={200}
                                                    colors={['#cca6a8ff', '#383c41ff', '#4d4fc9ff']}
                                                    labels={['Port Load 35%', 'Manoeuv 0%', 'Other']}
                                                />
                                            </Col>
                                        </Row>
                                        <div style={{ marginTop: '15px' }}>
                                            <Title level={5} style={{ color: 'dark', marginBottom: '10px' }}>
                                                Machinery Performance
                                            </Title>
                                            <Row>
                                                <Col span={12}>
                                                    <ExecutivePieChart options={loadProfilePie}
                                                        series={[2, 0, 1]}
                                                        type="pie"
                                                    height={200}
                                                        colors={['#cca6a8ff', '#383c41ff', '#c0be45ff']}
                                                        labels={['Port Load 35%', 'Manoeuv 0%', 'Other']}
                                                    />
                                                </Col>
                                                <Col span={12}>
                                                    <Chart
                                                        options={machineryDonut}
                                                        series={[37, 35, 28]}
                                                        type="donut"
                                                        height={250}
                                                    />
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </Col>


                                <Col xs={24} md={12} lg={12}>
                                    <div>
                                        <Title level={5} style={{ color: 'dark', marginBottom: '15px' }}>
                                            Fuel & Lubrication Monitoring
                                        </Title>

                                        <div style={{ marginBottom: '10px' }}>
                                            <Typography.Text style={{ color: 'dark', fontSize: '12px', fontWeight: 'bold' }}>Fuel Balance</Typography.Text>
                                            <Typography.Text style={{ color: 'grey', fontSize: '11px', display: 'block' }}>
                                                Compares bunker intake vs total consumption and ROB across HFO, MGO, and DO
                                            </Typography.Text>
                                        </div>

                                        <div style={{ marginBottom: '10px' }}>
                                            <Typography.Text style={{ color: 'dark', fontSize: '12px', fontWeight: 'bold' }}>Sludge Generation</Typography.Text>
                                            <Typography.Text style={{ color: 'grey', fontSize: '11px', display: 'block' }}>
                                                Tracks percentage of sludge vs total fuel consumed to ensure MARPOL compliance.
                                            </Typography.Text>
                                        </div>

                                        <div style={{ marginBottom: '15px' }}>
                                            <Typography.Text style={{ color: 'dark', fontSize: '12px', fontWeight: 'bold' }}>Lube Oil Consumption</Typography.Text>
                                            <Typography.Text style={{ color: 'grey', fontSize: '11px', display: 'block' }}>
                                                Monthly and cumulative consumption trends within to machinery wear and oil quality.
                                            </Typography.Text>
                                        </div>

                                        <Chart
                                            options={fuelBarChart}
                                            series={[{
                                                name: 'Fuel Performance',
                                                data: [30, 20, 15]
                                            }]}
                                            type="bar"
                                            height={200}
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Typography.Text style={{ color: 'grey', fontSize: '11px', marginTop: '15px', display: 'block' }} className='text-center'>
                                This detailed insight allows management to prioritize maintenance, reduce operational costs, and enhance energy efficiency by targeting underperforming systems or oper.
                            </Typography.Text>
                        </Card>

                    </Col>
                </div>


                {/* IMAGE 3 */}
                <div ref={dashboardRef3}   >
                    <Row gutter={[16, 16]}>



                        {/* Energy Efficiency Metrics */}
                        {/* <Col xs={24} lg={24}>
                            <Card className='executivebox1'>

                                <Title level={5} style={{ color: 'dark', marginBottom: '15px' }}>
                                    Energy Efficiency Metrics
                                </Title>

                                <Row gutter={[8, 8]}>
                                    <Col span={8}>
                                        <MarineGaugeChart
                                            value={23}
                                            type="percentage"
                                            size={250}
                                            label={"Hull Effiency"}
                                        />
                                        <GaugeChart label={"Hull Effiency"} type={"percentage"} value={23} />
                                    </Col>
                                    <Col span={8}>
                                        <GaugeChart label={"Main Engine Efficiency"} type={"percentage"} value={65} />

                                    </Col>
                                    <Col span={8}>
                                        <GaugeChart label={"Auxiliary Engine Efficiency"} type={"percentage"} value={59} />

                                    </Col>
                                    <Col span={8}>

                                        <GaugeChart label={"Boiler Efficiency"} type={"percentage"} value={79} />

                                    </Col>
                                    <Col span={8}>
                                        <GaugeChart label={"Rapid Efficiency"} type={"percentage"} value={85} />

                                    </Col>
                                    <Col span={8}>
                                        <GaugeChart label={"Engine Efficiency"} type={"percentage"} value={72} />

                                    </Col>
                                </Row>

                            </Card>
                        </Col> */}


                    </Row>
                    <Row gutter={12} className='mt-3'>
                        <Col xs={24} lg={12}>
                            <Card className='executivebox2'>
                                <Chart
                                    options={portSeaLoadOptions}
                                    series={portSeaLoadSeries}
                                    type="bar"
                                />

                                <Row gutter={[8, 8]}>
                                    <Col span={8}>
                                        <Chart
                                            options={createGaugeChart(94, 'Port Load vs Sea Load', '#1890ff')}
                                            series={[94]}
                                            height={400}
                                            type="radialBar"
                                        />
                                    </Col>
                                    <Col span={8}>
                                        <Chart
                                            options={createGaugeChart(88, 'Fuel Efficiency', '#52c41a')}
                                            series={[88]}
                                            type="radialBar"
                                            height={400}

                                        />
                                    </Col>
                                    <Col span={8}>
                                        <Chart
                                            options={createGaugeChart(69, 'Boiler Efficiency', '#faad14')}
                                            series={[69]}
                                            type="radialBar"
                                            height={400}

                                        />
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col xs={24} lg={12}>
                            <Card className='executivebox2' >
                                <Chart
                                    options={chartOptions}
                                    series={chartSeries}
                                    type="bar"
                                    height={400}
                                />

                            </Card>
                        </Col>
                    </Row>
                    <Row gutter={16} className='mb-3'>

                        <Col xs={24} lg={12}>
                            <Card className='executivebox2' style={{ marginTop: '15px' }}>
                                <Chart
                                    options={fuelLubricationOptions}
                                    series={fuelLubricationSeries}
                                    type="bar"
                                    height={350}
                                />

                            </Card>
                        </Col>
                        <Col xs={24} lg={12}>
                            <Card className='executivebox2' style={{ marginTop: '15px' }}>


                                <Chart
                                    options={offHireEventsOptions}
                                    series={offHireEventsSeries}
                                    type="bar"
                                    height={180}
                                />



                                <Chart
                                    options={fuelBalanceOptions}
                                    series={fuelBalanceSeries}
                                    type="bar"
                                    height={250}
                                />
                            </Card>
                        </Col>


                    </Row>

                </div>


                {/* IMAGE 4 - Vessel Energy & Performance Dashboard */}
                <Row gutter={12} className='mt-3 ' ref={dashboardRef4}  >
                    <Col span={24}>
                        <Card style={glassyCardStyle} bodyStyle={{ padding: '15px' }}>
                            <Title level={4} className="fw-bold text-center text-dark mb-3">
                                Vessel Energy & Performance Dashboard
                            </Title>

                            <Row gutter={[16, 16]}>
                                {/* Overall Performance Circle */}

                                {/* Hull Efficiency Metrics */}
                                <Col xs={24} lg={12}>

                                    <Chart
                                        options={createHorizontalBar(['A', 'B', 'C', 'D', 'E'], "Hull Efficiency Metrics")}
                                        series={[
                                            { name: 'Low', data: [20, 15, 25, 30, 20] },
                                            { name: 'Medium', data: [30, 35, 25, 20, 30] },
                                            { name: 'High', data: [50, 50, 50, 50, 50] }
                                        ]}
                                        type="bar"
                                        height={400}
                                    />
                                </Col>
                                <Col xs={24} lg={12}>
                                    <div style={{ textAlign: 'center' }}>
                                        <Chart
                                            options={fleetPerformanceDonut}
                                            series={[75, 25]}
                                            type="donut"
                                            height={350}
                                        />
                                    </div>
                                </Col>


                            </Row>

                            <Row gutter={[16, 16]} style={{ marginTop: '20px' }}>
                                {/* Main Engine Efficiency */}
                                <Col xs={24} md={12}>

                                    <Chart
                                        options={createHorizontalBar(['A', 'B', 'C'], " Main Engine Efficiency")}
                                        series={[
                                            { name: 'Low', data: [20, 15, 25] },
                                            { name: 'Medium', data: [30, 25, 35] },
                                            { name: 'High', data: [50, 60, 40] }
                                        ]}
                                        type="bar"
                                        height={350}
                                    />
                                </Col>

                                {/* Operational Load */}
                                <Col xs={24} lg={12}>

                                    <Chart
                                        options={createHorizontalBar(['A', 'B', 'C'], "Operational Load")}
                                        series={[
                                            { name: 'Low', data: [15, 10, 20] },
                                            { name: 'Medium', data: [25, 20, 30] },
                                            { name: 'High', data: [60, 70, 50] }
                                        ]}
                                        type="bar"
                                        height={350}
                                    />
                                </Col>
                            </Row>

                            <Row>
                                {/* Fuel & Maintenance */}
                                <Col xs={24} md={12}>

                                    <Chart
                                        options={createHorizontalBar(['A', 'E'], " Fuel & Maintenance")}
                                        series={[
                                            { name: 'Low', data: [15, 20] },
                                            { name: 'Medium', data: [25, 30] },
                                            { name: 'High', data: [60, 50] }
                                        ]}
                                        type="bar"
                                        height={350}
                                    />
                                </Col>
                                <Col xs={24} md={12}>

                                    <Chart
                                        options={createHorizontalBar(['A', 'E'], " Auxiliary Engine Efficienc")}
                                        series={[
                                            { name: 'Low', data: [20, 25] },
                                            { name: 'Medium', data: [30, 35] },
                                            { name: 'High', data: [50, 40] }
                                        ]}
                                        type="bar"
                                        height={350}
                                    />
                                </Col>
                            </Row>


                        </Card>
                    </Col>
                </Row>


            </div>
        </MobileContainer>
    );
};

export default ExecutiveSummary;